<mat-card>
  <mat-card-title>Accounts</mat-card-title>
  <button mat-raised-button color="primary" routerLink="/accounts/new">
    Create new
  </button>

  <mat-form-field>
    <mat-label>Year</mat-label>
    <mat-select [value]="year" (selectionChange)="load($event.value)">
      <mat-option [value]="null">All</mat-option>
      <mat-option *ngFor="let year of years" [value]="year">{{
        year
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <table mat-table [dataSource]="datasource" matSort class="mat-elevation-z8">
    <!-- Each Column -->
    <!-- <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef> {{column | titlecase}} </th>
            <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
        </ng-container> -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="permaId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PermaId</th>
      <td mat-cell *matCellDef="let element">{{ element.permaId }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="emailsSent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Emails Sent</th>
      <td mat-cell *matCellDef="let element">
        {{ element.emailsSent || '-' }}
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="outstanding">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Outstanding </th>
            <td mat-cell *matCellDef="let element"> {{element.outstanding}} </td>
        </ng-container> -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <a mat-raised-button [routerLink]="['/accounts/' + element.permaId]"
          >View</a
        >
        <a
          mat-raised-button
          [routerLink]="['/admin/accounts/' + element.permaId]"
          >Edit</a
        >
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-card>
